import React, { Dispatch } from 'react';
import { IServerErrorResponse } from '../../types';

export interface IContext {
    isTrustSelected: boolean,
    setIsTrustSelected: Dispatch<React.SetStateAction<boolean>>,
    setActiveStep: Dispatch<React.SetStateAction<number>>,
    setLocalMfaType: Dispatch<React.SetStateAction<any>>,
    reqOtpPayload: any,
    onSuccess: (data?:any) => void,
    onExternalFlowError: (errData: IServerErrorResponse) => void,
    billId: string,
    contextType: string,
}

export enum ActionStatus {
    MFA_REQUIRED = 'MFA_REQUIRED',
    MFA_CHALLENGE = 'MFA_CHALLENGE',
    SUCCESS = 'SUCCESS',
}

export enum MfaActionType {
    WIRE_OUT = 'WIRE_OUT',
    ACH_OUT = 'ACH_OUT',
    INVITE_ACCOUNTANT= 'INVITE_ACCOUNTANT'
}

export enum MfaType {
    SMS = 'SMS',
    VOICE = 'VOICE'
}

export enum DigitsNumAccordingToType {
    SMS = 6,
    VOICE = 5
}

export interface IMfaErrorData {
    stepToSwitch: number | null,
    shouldShowLocalErrorState: boolean,
    isExternalFlowError: boolean,
    errorCode: number | undefined,
    shouldShowGenericError?: boolean
    rawErrorData?: IServerErrorResponse,
    errorMessage?: string,
}
